export default "__VITE_ASSET__LUtOe63T__"